module.exports = __webpack_public_path__ + "static/img/rank_81.3a6c71a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_81.png
// module id = D6GO
// module chunks = 1